import React from 'react';
import { Section } from './Shared';
import { Daisy, FlowerSpike, Sprig } from './FloralDecor';
const steps: {
  name: string;
  text: string;
}[] = [{
  name: 'Prepare',
  text: 'Review the consultation framework and choose the reference pages you may need.'
}, {
  name: 'Explore',
  text: 'Use formula and case studies as educational examples within the traditional Bach Flower framework.'
}, {
  name: 'Record',
  text: 'Keep factual notes and follow-up information organized.'
}, {
  name: 'Reflect',
  text: 'Revisit boundaries, workload, and the way your practice is structured.'
}];
export function Workflow() {
  return <Section className="max-w-5xl" data-id="element-241" data-mp="27yw4td3ote5m">
      <div className="relative overflow-hidden rounded-xl border border-stone-200 rice-paper p-6 md:p-12" data-id="element-242" data-mp="27vqe5tfeu47s">
        <Sprig className="pointer-events-none absolute -right-6 -top-6 h-56 w-32 text-emerald-600/15" data-id="element-243" data-mp="djjqvw98rwz4" />
        <Daisy className="pointer-events-none absolute -left-4 -top-4 h-20 w-20" petalClassName="text-white" centerClassName="text-amber-300" data-id="element-244" data-mp="iimynoglwhas" />
        <FlowerSpike className="pointer-events-none absolute -bottom-6 left-[4%] hidden h-36 w-10 md:block" petalClassName="text-violet-300/60" centerClassName="text-emerald-300/60" data-id="element-245" data-mp="1vr2mj0j64ki1" />
        <div className="relative" data-id="element-246" data-mp="1h0dbby5pj5e6">
          <h2 className="text-center text-2xl font-bold tracking-tight text-emerald-900 md:text-4xl" data-id="element-247" data-mp="1h14z4mt2bytw">
            Keep useful materials together
          </h2>
          <p className="mx-auto mt-5 max-w-2xl text-center text-base leading-relaxed text-stone-700 md:text-lg" data-id="element-248" data-mp="29or86al27vo5">
            When consultation prompts, case examples, record pages, and practice-planning notes are scattered across
            different files, it can take extra effort to find the right reference.
          </p>
          <p className="mx-auto mt-4 max-w-2xl text-center text-base leading-relaxed text-stone-700 md:text-lg" data-id="element-249" data-mp="tarbr9lfao5n">
            The Bach Flower Consultation Guide brings these resources together in a consistent digital library:
          </p>

          <ol className="mt-10 grid gap-px overflow-hidden rounded-lg border border-stone-200 bg-stone-200 sm:grid-cols-2 lg:grid-cols-4" data-id="element-250" data-mp="qqusqb2zyenx">
            {steps.map((step, index) => <li key={step.name} className="flex flex-col bg-white p-5" data-id="element-251" data-mp="grdl3o46pqpb" data-mpi={index}>
                <span className="flex h-8 w-8 items-center justify-center rounded-full bg-emerald-800 text-sm font-semibold text-amber-200" data-id="element-252" data-mp="lq6xtebnddof">
                  {index + 1}
                </span>
                <p className="mt-4 text-lg font-bold text-emerald-900" data-id="element-253" data-mp="cqjw0rf0a5uu">{step.name}</p>
                <p className="mt-1.5 text-sm leading-relaxed text-stone-700" data-id="element-254" data-mp="3u7bl81uq0d0t">{step.text}</p>
              </li>)}
          </ol>

          <p className="mx-auto mt-8 max-w-2xl text-center text-sm italic leading-relaxed text-stone-500 md:text-base" data-id="element-255" data-mp="310djmv7ge0i">
            The material supports your learning and organization; it does not make decisions for you or replace
            professional judgment.
          </p>
        </div>
      </div>
    </Section>;
}